import { Flex } from '@chakra-ui/react'
import { FormTextInput } from 'src/components/common/Forms/FormTextInput'
import { InvoiceFormInputs } from './InvoiceEditForm'
import InvoiceEditorSection from './InvoiceEditorSection'

const InvoiceDateInformation = () => {
  return (
    <InvoiceEditorSection title="日付の情報" number={3}>
      <Flex gap="8px">
        <FormTextInput<InvoiceFormInputs>
          type="date"
          name="billing_date"
          isRequired
          w="160px"
          label="請求書発行日"
        />
        <FormTextInput<InvoiceFormInputs>
          type="date"
          name="payment_deadline"
          isRequired
          w="160px"
          label="お支払期限"
        />
        <FormTextInput<InvoiceFormInputs>
          type="date"
          name="sales_date"
          isRequired
          w="160px"
          label="売上発生日"
        />
      </Flex>
    </InvoiceEditorSection>
  )
}

export default InvoiceDateInformation
